import * as React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import { Sheet, SheetContent } from "@/components/ui/sheet";

export const AppShell: React.FC = () => {
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const { pathname } = useLocation();
  const isDashboard = pathname === "/dashboard" || pathname === "/";

  return (
    <div
      data-testid="app-shell"
      className={isDashboard ? "min-h-screen bg-background text-foreground lg:h-dvh lg:overflow-hidden" : "min-h-screen bg-background text-foreground"}
    >
      <div className={isDashboard ? "flex min-h-screen lg:h-dvh lg:overflow-hidden" : "flex min-h-screen"}>
        <div className="hidden w-[190px] shrink-0 xl:w-[205px] md:block">
          <div className="sticky top-0 h-screen">
            <Sidebar />
          </div>
        </div>

        <div className={isDashboard ? "flex min-w-0 flex-1 flex-col lg:min-h-0 lg:overflow-hidden" : "flex min-w-0 flex-1 flex-col"}>
          {isDashboard ? <div className="lg:hidden"><Topbar onMenuClick={() => setMobileOpen(true)} /></div> : <Topbar onMenuClick={() => setMobileOpen(true)} />}
          <main
            data-testid="app-main"
            className={isDashboard ? "flex-1 px-2 py-2 sm:px-3 lg:min-h-0 lg:overflow-hidden" : "flex-1 px-4 py-8 sm:px-6 md:px-10 md:py-12"}
          >
            <div className={isDashboard ? "w-full min-w-0 lg:h-full" : "mx-auto w-full max-w-6xl"}>
              <Outlet />
            </div>
          </main>
          {!isDashboard ? (
            <footer className="border-t border-border px-4 py-4 text-[11px] text-muted-foreground sm:px-6">
              <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-2">
                <span>© {new Date().getFullYear()} Kartalyuvası — IFM Analiz</span>
                <span className="font-mono">v0.1.0 • iskelet</span>
              </div>
            </footer>
          ) : null}
        </div>
      </div>

      <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
        <SheetContent side="left" className="w-[300px] p-0" data-testid="mobile-sidebar">
          <Sidebar onNavigate={() => setMobileOpen(false)} />
        </SheetContent>
      </Sheet>
    </div>
  );
};
